<ng-content></ng-content>
<ng-template>
  <h2 matDialogTitle>수강중인 학생 목록</h2>
  <mat-dialog-content>
    <app-lecture-member-list [lecture]="lecture"></app-lecture-member-list>
  </mat-dialog-content>
</ng-template>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-members-button/lecture-members-button.component.html